/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');
var latinize = require('latinize');

module.exports = function (helpers, utils) {

    var returnResult = utils.returnResult;

    return {
        kebab: function (options, str) {
            if (!str || !_.isString(str)) {
                return '';
            }

            return _.kebabCase(str);
        },
        kebabPrintableChars: function (options, str) {
            if (!str || !_.isString(str)) {
                return '';
            }

            str = latinize(str);
            return _.kebabCase(str);
        },

        unescape: function (options, str) {
            return _.unescape(str);
        },

        replace: function (options) {
            var args = options.args;
            var str = args[0];

            if (!str || !_.isString(str)) {
                return '';
            }

            if (args.length < 4) {
                return str;
            } else {
                return str.replace(new RegExp(args[1], 'g'), args[2]);
            }
        },

        lower: function (options, str) {

            if (!str || !_.isString(str)) {
                return returnResult(options, this, '');
            }

            return returnResult(options, this, str.toLowerCase());
        },

        capitalize: function (options, str) {

            if (!str || !_.isString(str)) {
                return returnResult(options, this, '');
            }

            return returnResult(options, this, _.capitalize(str.toLowerCase()));
        },

        capitalizedWords: function (options, str) {
            if (!str || !_.isString(str)) {
                return returnResult(options, this, '');
            }

            return returnResult(options, this, _.reduce(str.replace(/\s+/g, ' ').split(' '), function (accum, v) {
                return accum + ' ' + v[0].toUpperCase() + v.substr(1);
            }, '').trim());
        },

        upper: function (options, str) {
            if (!str || !_.isString(str)) {
                return returnResult(options, this, '');
            }

            return returnResult(options, this, str.toUpperCase());
        },

        snake: function (options, str) {
            if (!str || !_.isString(str)) {
                return '';
            }

            return _.snakeCase(str);
        },

        substr: function (options, str, index) {
            if (!str || !_.isString(str)) {
                return '';
            }

            return str.substr(0, index);
        },

        concat: function (options) {
            return options.args.join('');
        },

        startsWith: function (options, str, term) {
            if (!_.isString(str) || !_.isString(term)) {
                return returnResult(options, this, false);
            }
            return returnResult(options, this, _.startsWith(str, term));
        },

        format: function (options, str, root) {
            return _.replace(str, /\{(\S+)\}/gi, function (matchedParam, matchedParamValue) {
                return _.get(root, matchedParamValue, '');
            });
        },

        firstCharStr: function (options, str) {
            return str.substring(0,1);
        }
    };
};
